/**
 * Region-aware price string to number conversion.
 * Delegates to currency.js which handles both BR and US formats.
 */
import { convertPrice as currencyConvertPrice } from './currency';

export function convertPrice(price) {
  return currencyConvertPrice(price);
}
